import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  baseURL: "https://db.globequestsafaris.com/api/",
  //baseURL: "http://localhost:12003/api/",
});

const writeAxiosInstance = axios.create({
  baseURL: "https://db.globequestsafaris.com/api/",
  //baseURL: "http://localhost:12003/api/",
});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;
